import axios from 'axios';
import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// Create Organisation
export const createOrganisation = async (data: any) => {
	const URL = `${API_URL}CreateOrganisation`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);

	// Check if data is FormData (file upload) or regular object
	const requestData = {
		createOrganisationToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Update Organisation
export const updateOrganisation = async (data: any) => {
	const URL = `${API_URL}UpdateOrganisation`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		updateOrganisationToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Get Organisation
export const getOrganisation = async (data: any) => {
	const URL = `${API_URL}GetOrganisation`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		getOrganisationToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Get All Organisations
export const getAllOrganisations = async (data: any) => {
	const URL = `${API_URL}GetAllOrganisations`;
	const requestData = {
		getAllOrganisationsToken: data,
	};

	return makeApiCall(URL, requestData);
};

// Update Organisation Status
export const updateOrganisationStatus = async (data: any) => {
	const URL = `${API_URL}UpdateOrganisationStatus`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		updateOrganisationStatusToken: data,
	};
	return makeApiCall(URL, requestData);
};
